<template>
  <div>
    <el-row :gutter="20">
      <el-col>
        店铺商品同步记录
        <el-button type="primary" style="margin-left: 15px" icon="el-icon-refresh" @click="getDataList" :loading="loading" circle></el-button>
      </el-col>
    </el-row>
    <el-card>
      <el-table :data="logList" v-loading="loading" element-loading-text="数据加载中">
        <el-table-column
          prop="id"
          label="任务ID"
          width="100">
        </el-table-column>
        <el-table-column
          prop="items_count"
          label="SKU总数">
        </el-table-column>
        <el-table-column
          prop="distributor_count"
          label="店铺总数">
        </el-table-column>
        <el-table-column
          prop="created"
          label="开始时间">
        </el-table-column>
        <el-table-column
          prop="finish_time"
          label="完成时间">
        </el-table-column>
        <el-table-column
          label="进度"
          width="200">
          <template  slot-scope="scope">
            <el-progress type="circle" :percentage="scope.row.rate" :color="colors" width="50"></el-progress>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-padded content-center">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :total="total_count"
          :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
  import { getItemSyncDistributorLog } from '../../../api/goods'
  export default {
    data () {
      return {
        logList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 10,
        },
        form: {

        },
        colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#1989fa', percentage: 60},
          {color: '#6f7ad3', percentage: 80},
          {color: '#5cb87a', percentage: 100}
        ]
      }
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {
        this.loading = true
        getItemSyncDistributorLog(this.params).then(response => {
          this.logList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
</style>
